package us.laantech.common.util

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid


@OptIn(ExperimentalUuidApi::class)
fun generateUUIDv7(): String {
    return Uuid.generateV7().toHexDashString()
}